import { Search } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { TextField } from "@similarweb/ui-components/forms";
import { Flex, Stack, Text } from "@similarweb/ui-components/foundations";

import { CAMPAIGN_WIZARD_TRANSLATIONS } from "../translations";

interface ICountriesSearchHeaderProps {
    searchQuery: string;
    selectedCount: number;
    onSearchChange: (query: string) => void;
}

export const CountriesSearchHeader = ({ searchQuery, selectedCount, onSearchChange }: ICountriesSearchHeaderProps) => {
    return (
        <Stack
            position="sticky"
            top="0"
            zIndex="1"
            gap="16px"
            background={colorsPalettes.carbon["0"]}
        >
            <Flex
                justifyContent="space-between"
                alignItems="start"
                width="100%"
            >
                <Stack gap="4px">
                    <Text
                        fontVariant="body2"
                        color={colorsPalettes.carbon["500"]}
                    >
                        {CAMPAIGN_WIZARD_TRANSLATIONS.countries.descriptionLine1.translate()}
                    </Text>
                    <Text
                        fontVariant="body2"
                        color={colorsPalettes.carbon["500"]}
                        dangerouslySetInnerHTML={{
                            __html: CAMPAIGN_WIZARD_TRANSLATIONS.countries.descriptionLine2.translate(),
                        }}
                    />
                </Stack>

                <Text
                    fontVariant="tooltip"
                    color={colorsPalettes.carbon["500"]}
                >
                    {CAMPAIGN_WIZARD_TRANSLATIONS.countries.selectedCount.translate({
                        count: selectedCount,
                        plural: selectedCount > 1 ? "s" : "",
                    })}
                </Text>
            </Flex>
            <TextField
                value={searchQuery}
                onChange={(value) => onSearchChange(value)}
                placeholder={CAMPAIGN_WIZARD_TRANSLATIONS.countries.searchPlaceholder.translate()}
                startAddon={
                    <Search
                        size="sm"
                        color={colorsPalettes.carbon["200"]}
                    />
                }
            />
        </Stack>
    );
};
